// 覚醒王の戦いだけ舞台を 1.4 倍に広げてカメラで追う (2026-10-27)。配布版の既定 = 広い舞台 (10-27 作者「広い方が良い」「広い舞台＋下がって構える版を配布版に」)。
//   開発版の見比べ: ?awokenStage=narrow で旧の舞台 (1 倍・カメラ止め)。
//   作者 (10-27・噛みの間合いの検収の気づき)「もしかしてボスの大きさに対してステージの大きさが足りてないのが一番の問題？」
//   王は床 840px のうち約 315px を体で使い、体の中心は 160〜800 しか動けない。1.4 倍なら床 1176px・体の中心 -8〜968。
//   07-28 に作者が決めた「舞台 1.4 倍」(騎士の背景が足りず畳んだ) の仕組み (balance.ts setArenaWidthMul・render.ts のカメラ) をそのまま使う。
//   覚醒王の背景 (awoken-room.png・1672x941) は横長の絵ではないので、床の線を基準に縦横同じ倍率で拡大して埋める (render.ts drawBackground の既存の経路)。
//   カメラ余白は 240 (08-02 に騎士で「寄りは許容」とした値)。背景の拡大は約 1.44 倍・上の約 190px が切れる。
//   ?awokenBiteSpace=keep と組んで使う (好みの距離 235px まで下がってから噛む)。当たり・技・絵は変えない。
import { getArenaWidthMul, getCameraMarginPx, setArenaWidthMul, setCameraMarginPx } from './balance'

export const AWOKEN_WIDE_STAGE_MUL = 1.4
export const AWOKEN_WIDE_STAGE_CAMERA_MARGIN_PX = 240

let on = true
// いま広げているか (覚醒王の戦いの間だけ true)。戻す時に元の余白へ戻す。
let applied = false
let savedMargin = 0

/** 開発版の切り替え (game.ts)。指定なし = 広い舞台。 */
export function setAwokenWideStage(v: string | null): boolean {
  on = v !== 'narrow' && v !== '0'
  return on
}
export function awokenWideStageOn(): boolean { return on }

/** 毎コマ (main.ts)。覚醒王の戦いの間だけ舞台を広げ、それ以外は元へ戻す。カメラの入切は呼び出し側 (render.ts) に任せ、戻り値で伝える。 */
export function syncAwokenWideStage(bossId: string | undefined): 'apply' | 'restore' | null {
  if (!on) return null
  const want = bossId === 'crowned-king-awoken'
  if (want && !applied) {
    applied = true
    savedMargin = getCameraMarginPx()
    setArenaWidthMul(AWOKEN_WIDE_STAGE_MUL)
    setCameraMarginPx(AWOKEN_WIDE_STAGE_CAMERA_MARGIN_PX)
    return 'apply'
  }
  if (!want && applied) {
    applied = false
    if (getArenaWidthMul() === AWOKEN_WIDE_STAGE_MUL) setArenaWidthMul(1)
    setCameraMarginPx(savedMargin)
    return 'restore'
  }
  return null
}
